// Container.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';

class Container extends Component {
  render() {
    const { match } = this.props;
    const { location } = this.props;

    const params = new URLSearchParams(this.props.location.search);
    const hideHeaderFooter = params.get('hf') === 'false';

    return (
      <section>
        {/* Condiciona a renderização do Header */}
        {!hideHeaderFooter && <Header {...this.props} />}

        <div className="ls-main">
          {this.props.children}
        </div>

        {/* Condiciona a renderização do Footer */}
        {!hideHeaderFooter && <Footer {...this.props} />}

        {/* Botão do WhatsApp, renderizado condicionalmente */}
        {!hideHeaderFooter && (
          <a
            href="https://hubs.li/Q018X1gc0"
            className="wpp-button"
            target="_blank"
            rel="noopener noreferrer"
            id="whatsapp_ico"
            style={{
              position: 'fixed',
              width: '60px',
              height: '60px',
              bottom: '40px',
              right: '40px',
              backgroundColor: '#25d366',
              color: '#fff',
              borderRadius: '50px',
              textAlign: 'center',
              fontSize: '30px',
              boxShadow: '2px 2px 3px #999',
              zIndex: 1000
            }}
          >
            <i className="fab fa-whatsapp my-float" style={{ marginTop: '16px' }}></i>
          </a>
        )}
      </section>
    );
  }
}

Container.propTypes = {
  children: PropTypes.element,
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(Container);
